import styled from "styled-components";
import { Link } from "react-router-dom";

const News = (props) => {
    return(
       <Container>

          <Caption>
          <span>Recent News</span>
                <h2>Success story posts</h2>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor <br/> incididunt ut labore et dolore magna aliqua.</p>
          </Caption>

          <Stories>
              <Story>
                  <img src ="/images/gallery/services2.png" alt = "" />
                  <Date>September 07, 2020</Date>
                  <h3>Tips for saving money and better guide for investment</h3>
                  <Link  to = "/">Read More</Link>
              </Story>
              <Story>
                  <img src ="/images/gallery/services3.png" alt = "" />
                  <Date>August 05, 2021</Date>
                  <h3>Financing loans available to small businesses</h3>
                  <Link  to = "/">Read More</Link>
              </Story>
              <Story>
                  <img src ="/images/gallery/services4.png" alt = "" />
                  <Date>December 08, 2022</Date>
                  <h3>5 ways you can prepare your business for success</h3>
                  <Link  to = "/">Read More</Link>
              </Story>
          </Stories> 

       </Container>
    )
}


const Container = styled.div`
    padding: 50px 20px;

    @media(min-width: 768px){
        padding: 50px;
    }
`

const Caption = styled.div`
    text-align: center;

    span{
        color: rgb(231, 60, 62);
    }
`
const Stories = styled.div`
    display: flex;
    flex-direction: column;

    @media(min-width: 768px){
        justify-content: space-between;
        flex-direction: row;
    }

`


const Story = styled.div`
    margin-bottom: 20px;

    img{
        width: 100%;
        object-fit: contain;
    }

    h3{
        transition: all 0.5s ease-in;
        @media(min-width: 768px){
            font-size: 25px;
            line-height: 35px;
        }  
    }

    h3:hover{
        color: rgb(231, 60, 62);
    }
    a{
        color: rgb(0, 0, 0);
        transition: all 0.3s ease-in;
    }
    a:hover{
        color: rgb(231, 60, 62);
        font-weight: 500;
        font-size: 17px;
    }

    @media(min-width: 768px){
        width: 32%;
    }
`

const Date = styled.span`
    color: rgb(231, 60, 62);
    font-family: 'Rubik', sans-serif;
    font-size: 16px;
    line-height: 24px;
`
export default News